<script lang="ts" setup>
import { useBasketStore } from '@/store/basket/basket'

import {
  type AdditiveItem,
  type Gift,
  type Item,
} from '@/types/api/api-v3/basket'

import BasketOrderAdditiveItem from '@/components/Basket/basket-order/BasketOrderAdditiveItem.vue'
import BasketOrderGiftItem from '@/components/Basket/basket-order/BasketOrderGiftItem.vue'
import BasketOrderItem from '@/components/Basket/basket-order/BasketOrderItem.vue'

type Props = {
  items: Item[]
  giftsWithoutChoice: Gift[]
  additives: AdditiveItem[]
}

const props = defineProps<Props>()

const basketStore = useBasketStore()

const selectedGiftPayload = computed(() => basketStore.getSelectedGift)

const selectedGift = computed(() => {
  if (!selectedGiftPayload.value && !Array.isArray(selectedGiftPayload.value)) {
    return null
  }

  const giftWithChoice = basketStore.giftsOfChoice

  const { product_id, rule_id } = selectedGiftPayload.value

  if (!product_id || !rule_id) return null

  for (const { products, title } of giftWithChoice) {
    for (const product of products) {
      if (product.product_id === product_id) {
        return {
          ...product,
          giftTitle: title,
        }
      }
    }
  }
})

const cartView = () => {
  // Событие просмотра корзины в CarrotQuest
  // Необходимо выводить в отдельных массивах
  const titles_list: string[] = []
  const url_list: string[] = []
  const price_list: number[] = []
  const image_list: string[] = []

  props?.items?.map((item) => ({
    titles_list: titles_list.push(item.title),
    url_list: url_list.push(item.url),
    price_list: price_list.push(item.price),
    image_list: image_list.push(item.image_url),
  }))

  window.carrotquest?.track('$cart_viewed', {
    $name: titles_list,
    $url: url_list,
    $amount: price_list,
    $img: image_list,
  })
}

onMounted(() => cartView)
</script>

<template>
  <div class="order-list">
    <basket-order-item
      v-for="item in items"
      :key="item.product_id"
      class="order-list__item"
      :item="item"
    />

    <template v-for="additive in additives" :key="additive.product_id">
      <basket-order-additive-item
        :additive="additive"
        class="order-list__item"
      />
    </template>

    <template v-for="gift in giftsWithoutChoice" :key="gift.rule_id">
      <basket-order-gift-item
        v-for="product in gift.products"
        :key="product.product_id"
        :gift="product"
        :gift-title="gift.title"
        class="order-list__item"
      />
    </template>

    <template v-if="selectedGift">
      <basket-order-gift-item
        :gift="selectedGift"
        :gift-title="selectedGift.giftTitle"
        class="order-list__item"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.order-list {
  &__item {
    padding: 20px 0 15px;
    border-bottom: 1px solid var(--ui-grey);

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  }
}
</style>
